import { b1, b2, b3, b4, d1, d2, d3, l1, l2, l3, l4, l5 } from "../assets/index"

export  const data = [
  {
    id: 1,
    category: "breakfast",
    title: "Breakfast",
    img: b1,
    description: "Breakfast is the first meal of a day. The word in English refers to breaking the fasting period of the previous night.",
    price: "50"
  },
  {
    id: 2,
    category: "breakfast",
    title: "Breakfast",
    img: b2,
    description: "Breakfast is the first meal of a day. The word in English refers to breaking the fasting period of the previous night.",
    price: "80"
  },
  {
    id: 3,
    category: "breakfast",
    title: "Breakfast",
    img: b3,
    description: "Breakfast is the first meal of a day. The word in English refers to breaking the fasting period of the previous night.",
    price: "20"
  },
  {
    id: 4,
    category: "breakfast",
    title: "Breakfast",
    img: b4,
    description: "Breakfast is the first meal of a day. The word in English refers to breaking the fasting period of the previous night.",
    price: "64"
  },
  {
    id: 5,
    category: "dinner",
    title: "Dinner",
    img: d1,
    description: "A side dish, sometimes referred to as a side order, side item, or simply a side, is a food item that accompanies the entrée or main course at a meal. Side dishes such as salad, potatoes and bread are commonly used with main courses throughout many countries of the western world",
    price: "75"
  },
  {
    id: 6,
    category: "dinner",
    title: "Dinner",
    img: d2,
    description: "A side dish, sometimes referred to as a side order, side item, or simply a side, is a food item that accompanies the entrée or main course at a meal. Side dishes such as salad, potatoes and bread are commonly used with main courses throughout many countries of the western world",
    price: "61"
  },
  {
    id: 7,
    category: "dinner",
    title: "Dinner",
    img: d3,
    description: "A side dish, sometimes referred to as a side order, side item, or simply a side, is a food item that accompanies the entrée or main course at a meal. Side dishes such as salad, potatoes and bread are commonly used with main courses throughout many countries of the western world",
    price: "54"
  },
  {
    id: 8,
    category: "lunch",
    title: "Lunch",
    img: l1,
    description: "Beef is the culinary name for meat from cattle, particularly skeletal muscle. Humans have been eating beef since prehistoric times.[1] Beef is a source of high-quality protein and essential nutrients.",
    price: "24"
  },
  {
    id: 9,
    category: "lunch",
    title: "Lunch",
    img: l2,
    description: "Beef is the culinary name for meat from cattle, particularly skeletal muscle. Humans have been eating beef since prehistoric times.[1] Beef is a source of high-quality protein and essential nutrients.",
    price: "78"
  },
  {
    id: 10,
    category: "lunch",
    title: "Lunch",
    img: l3,
    description: "Beef is the culinary name for meat from cattle, particularly skeletal muscle. Humans have been eating beef since prehistoric times.[1] Beef is a source of high-quality protein and essential nutrients.",
    price: "102"
  },
  {
    id: 11,
    category: "lunch",
    title: "Lunch",
    img: l4,
    description: "Beef is the culinary name for meat from cattle, particularly skeletal muscle. Humans have been eating beef since prehistoric times.[1] Beef is a source of high-quality protein and essential nutrients.",
    price: "22"
  },
  {
    id: 12,
    category: "lunch",
    title: "Lunch",
    img: l5,
    description: "Beef is the culinary name for meat from cattle, particularly skeletal muscle. Humans have been eating beef since prehistoric times.[1] Beef is a source of high-quality protein and essential nutrients.",
    price: "78"
  },
  {
    id: 13,
    category: "snack",
    title: "snack",
    img: l5,
    description: "snacks snacks snacks snacks snacks snacks snacks snacks snacks snacks.",
    price: "78"
  }
]